import { PaginatedResult } from '../types';

export interface IMrtState {
  machineReadableTemplates: PaginatedResult | null;
}

export const MrtState: IMrtState = {
  machineReadableTemplates: null
};
